import { useMemo, useState } from 'react';
import {
  SortDirection,
  SortedColumn,
} from '../../../../../../shared/components/ResponsiveTable/models';
import ResponsiveTable from '../../../../../../shared/components/ResponsiveTable';
import { User } from '../../../../../../shared/models/UserModels';
import styles from '../BulkActionMenu.module.scss';

function sortTable(data: User[], fieldName: string, sortOrder: number) {
  const clone = [...data];
  return clone?.sort((a, b) =>
    // eslint-disable-next-line no-nested-ternary
    a[fieldName].toString().toLowerCase() ===
    b[fieldName].toString().toLowerCase()
      ? 0
      : a[fieldName].toString().toLowerCase() >
        b[fieldName].toString().toLowerCase()
      ? sortOrder
      : -sortOrder,
  );
}

const getColumns = (order: SortDirection): SortedColumn[] => [
  {
    name: 'email',
    title: 'Registered Emails',
    cell: ({ row }) => <span data-exclude-lg>{row.original.email}</span>,
    width: 45,
    sortingEnabled: true,
    direction: order,
  },
];

export interface RegisteredUsersProps {
  users: User[];
}

export default function RegisteredUsers({ users }: RegisteredUsersProps) {
  const [sortedColumn, setSortedColumn] = useState<SortedColumn>(null);
  const handleSort = (column: SortedColumn) => {
    setSortedColumn(column);
  };
  const list = useMemo(() => {
    if (sortedColumn?.direction) {
      const sortOrder = sortedColumn.direction === 'Asc' ? 1 : -1;
      return sortTable(users, sortedColumn?.name ?? 'name', sortOrder);
    }
    return users;
  }, [sortedColumn, users]);

  return (
    <ResponsiveTable
      data={list}
      onSort={handleSort}
      columns={getColumns(sortedColumn?.direction)}
      showPagination={false}
      className={`overflow-auto ${styles.modalTable}`}
    />
  );
}
